import Vue from "vue";
import VueRouter from "vue-router";
import Equivalences from "@/views/Equivalences.vue";
import Create from "@/views/Create.vue";
import Details from "@/views/Details.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: { path: "/equivalences", query: { status: "submitted,valid" } },
  },
  {
    path: "/equivalences",
    name: "Equivalences",
    component: Equivalences,
  },
  {
    path: "/equivalences/create",
    name: "Equivalences create",
    component: Create,
  },
  {
    path: "/equivalences/:_id",
    name: "Request details",
    component: Details,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
